import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs/Subscription';

import { RelatedInfluencer } from '../../../../../../models/influencer/related-influencer';
import { systemValues } from '../../../../../app.constants';
import { UserService } from '../../../../../services/user.service';

@Component({
    selector: 'related-influencer-item',
    templateUrl: './related-influencer-item.component.html',
    styleUrls: ['./related-influencer-item.component.scss']
})
export class RelatedInfluencerItemComponent implements OnInit, OnDestroy {
    public placeholderAvatar = systemValues.defaultUserAvatarPicture;
    public userAvatarPicture: string;

    public influencerlink: [string];
    public influencerlinkParams: any;
    private _readOnlyFixInfluencerlinkParams = { hideBackButton: true };
    private _activeAccountSubscription: Subscription;

    @Input() influencer: RelatedInfluencer;
    @Input() placeholderMode: boolean;

    constructor(private _userService: UserService) {
    }

    ngOnInit(): void {
        if (this.influencer) {
            this.userAvatarPicture = this.influencer.profilePicture;
            this.influencerlink = [`/influencer/${this.influencer.id}/overview`];
            this.influencerlinkParams = {
                ...this._readOnlyFixInfluencerlinkParams,
                activeAccount: this._userService.getCompanyId()
            };
            this._activeAccountSubscription = this._userService.companyId.subscribe({
                next: activeAccount => {
                    this.influencerlinkParams = {
                        ...this._readOnlyFixInfluencerlinkParams,
                        activeAccount
                    };
                }
            });
        }
    }

    ngOnDestroy(): void {
        if (this._activeAccountSubscription) {
            this._activeAccountSubscription.unsubscribe();
        }
    }

    public resolveNoAvatarUrl() {
        this.userAvatarPicture = this.placeholderAvatar;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/related-influencers/related-influencer-item/related-influencer-item.component.ts